import React from 'react'
import { useTranslation } from 'react-i18next'
import {List} from 'antd'
import {getAmountWithCurrency, isEmptyOrSpaces} from '@/utils'
import {ChargebackType} from '@/api'
import {Currencies, ChargebackStatus} from '@/constants'
import {DATE_FORMAT} from '@/stores/chargebacks/ChargebacksTableStore/constants'
import {Card, Description, DateTimeLabel, TableStatus, CardSchemeLabelWithIcon} from '@/components'
import {TagType} from '@/components/dumb/Tag/props'
import {MobileListProps} from './props'

import styles from './styles.scss'

export const ChargebacksTableMobile: React.FC<MobileListProps<ChargebackType>> = ({
    isLoading,
    dataSource,
    listExtra
}) => {
    const { t } = useTranslation()
    const { t: tEnums } = useTranslation('enums')

    return (
        <List
            loading={isLoading}
            itemLayout={'horizontal'}
            dataSource={dataSource}
            renderItem={(item) => {
                const {
                    id,
                    amount,
                    currency,
                    chargebackDate,
                    transactionDate,
                    status,
                    reasonCodeCategory,
                    cardScheme,
                    cardMask
                } = item

                return (
                    <Card
                        key={id}
                        title={
                            <strong>{getAmountWithCurrency(amount, currency as Currencies)}</strong>
                        }
                        extra={listExtra(item)}
                        className={styles.listItem}
                    >
                        <Description
                            dataSource={[
                                {
                                    label: t('ChargebacksTableMobile.chargebackDate'),
                                    key: 'chargebackDate',
                                    render: () => (
                                        <DateTimeLabel
                                            date={chargebackDate}
                                            dateFormat={DATE_FORMAT}
                                        />
                                    )
                                },
                                {
                                    label: t('ChargebacksTableMobile.transactionDate'),
                                    key: 'transactionDate',
                                    render: () => (
                                        <DateTimeLabel
                                            date={transactionDate}
                                            dateFormat={DATE_FORMAT}
                                        />
                                    )
                                },
                                {
                                    label: t('ChargebacksTableMobile.status'),
                                    key: 'status',
                                    render: () =>
                                        !isEmptyOrSpaces(status) ? (
                                            <TableStatus
                                                statusProps={{
                                                    status:
                                                        tEnums(`chargebackStatus.${status}`, { defaultValue: status }),
                                                    type:
                                                        status ===
                                                        ChargebackStatus['chargeback-reversal']
                                                            ? TagType.Success
                                                            : TagType.Default,
                                                    iconType: 'refund'
                                                }}
                                            />
                                        ) : null
                                },
                                {
                                    label: t('ChargebacksTableMobile.reason'),
                                    key: 'reasonCodeCategory',
                                    render: () =>
                                        tEnums(`reasonCodeCategory.${reasonCodeCategory}`, { defaultValue: reasonCodeCategory })
                                },
                                {
                                    label: t('ChargebacksTableMobile.paymentMethod'),
                                    key: 'paymentMethod',
                                    render: () => (
                                        <CardSchemeLabelWithIcon
                                            cardScheme={cardScheme}
                                            title={cardMask}
                                        />
                                    )
                                }
                            ]}
                        />
                    </Card>
                )
            }}
        />
    )
}
